import { getDisplayName, getDisplayPhoto } from "../stores/userDisplayUtils";

/**
 * 채팅 서버에서는 user_id만 오므로, 다른 서버(LIVE 등)에서 유저 정보(이름, 이미지, 중개사 정보 등)를 채워 반환.
 * 현재는 userDisplayUtils 기반, 추후 외부 API 호출로 확장.
 */
export function enrichUser(userId) {
  return {
    user_id: userId,
    name: getDisplayName(userId) || userId || "",
    avatarUrl: getDisplayPhoto(userId) || null,
  };
}

/** user_id 배열에 대해 enrichUser 적용 */
export function enrichUsers(userIds) {
  if (!Array.isArray(userIds)) return [];
  return userIds.map(enrichUser);
}

/** 캐시에 없는 user_id 목록 반환 */
export function getUnresolvedUserIds(userIds) {
  if (!Array.isArray(userIds)) return [];
  return userIds.filter((id) => !getDisplayName(id));
}